import { ConversationMessageContentType } from 'src/@types/conversation';

export const checkFileType = (type: string) => {
  if (type.startsWith('image')) return ConversationMessageContentType.IMAGE;
  if (type.startsWith('video')) return ConversationMessageContentType.VIDEO;
  if (type.startsWith('audio')) return ConversationMessageContentType.AUDIO;
  return ConversationMessageContentType.FILE;
};
